<template>
	<v-row>
		<v-col cols="7">
			<v-card>
				<v-card-title primary-title>
					Tugas
				</v-card-title>
				<v-card-text>
					<v-simple-table dense>
						<template v-slot:default>
							<tbody>
								<tr>
									<td style="width: 130px;"><b>Agenda</b></td>
									<td style="width: 10px;">:</td>
									<td>Hari ke {{ hari_ke }}, {{ formatDate(materi.tanggal) }}</td>
								</tr>
								<tr>
									<td><b>Nama</b></td>
									<td>:</td>
									<td>{{ materi.nama }}</td>
								</tr>
								<tr>
									<td><b>Deskripsi</b></td>
									<td>:</td>
									<td>
										<div v-html="nl2br(materi.deskripsi)"></div>
									</td>
								</tr>
								<tr>
									<td><b>Jenis Tugas</b></td>
									<td>:</td>
									<td>{{ materi.jenis_tugas }}</td>
								</tr>
								<tr>
									<td><b>Pemateri</b></td>
									<td>:</td>
									<td>{{ materi.nama_user }}</td>
								</tr>
								<tr>
									<td><b>File Materi</b></td>
									<td>:</td>
									<td>
										<a :href="materi.file_url" target="_blank">
											Lihat
										</a>
									</td>
								</tr>
								<tr>
									<td><b>Upload Tugas</b></td>
									<td>:</td>
									<td>
										<div v-if="materi.sudah_upload == 0">
											<input type="file" label="Pilih File" accept="application/pdf" ref="file"
												@change="onFileChange()" />
											<br />
											<v-btn small class="mt-4" color="primary" @click="upload">Upload</v-btn>
										</div>
										<a v-else :href="materi.file_upload_url" target="_blank">
											Lihat
										</a>
									</td>
								</tr>
								<tr v-if="materi.sudah_upload == 1">
									<td><b>Nilai Tugas</b></td>
									<td>:</td>
									<td>
										<b v-if="materi.nilai != null">{{ materi.nilai }}</b>
										<span v-else>Belum dinilai</span>
									</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>


				</v-card-text>
			</v-card>
		</v-col>
		<v-col cols="5">
			<v-card>
				<v-card-text>
					<h2 style="text-transform: capitalize;">{{ pelatihan.nama }}</h2>
					<h3>Detail Stakeholder Pelatihan:</h3>
					<div v-html="pelatihan.detail_stakeholder"></div>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>
</template>

<style scoped>
table tr td{
	vertical-align: top;
}
</style>

<script>
import { axiosPostAuth, axiosGetAuth } from '@/utils/axios'
import { mdiEye, mdiPencil, mdiMagnify, mdiPlus, mdiTrashCan, mdiLock } from '@mdi/js'

export default {
	components: {
	},
	data() {
		return {
			icons: {
				mdiEye,
				mdiPencil,
				mdiMagnify, mdiPlus, mdiTrashCan, mdiLock
			},
			id_pelatihan: this.$route.params.id_pelatihan,
			id_materi: this.$route.params.id_materi,
			hari_ke: this.$route.params.hari_ke,
			pelatihan: {},
			materi: {
				tanggal: '',
				nama: '',
				deskripsi: '',
				jenis_tugas: '',
				nama_user: '',
				file_url: '',
			},
			formUpload: {
				editedIndex: -1,
				file_temp: '',
				edit: {
					id_user: '',
					id_materi: '',
					file: '',
					file_url: '',
					created_at: '',
					nilai: '',
					nama_penilai: '',
					dinilai_at: '',
				}
			}
		}
	},
	watch: {
	},
	computed: {
	},
	created() {
		this.getPelatihan()
		this.getTugasPeserta()
	},
	methods: {
		onFileChange() {
			this.formUpload.file_temp = this.$refs.file.files.item(0)
		},
		getPelatihan() {
			const fmData = new FormData()
			fmData.append('id_pelatihan', this.id_pelatihan)
			axiosPostAuth('api/Pelatihan/getPelatihan', fmData)
				.then(response => {
					this.pelatihan = Object.assign({}, response.data)
				})
				.catch(error => {
					alert(error)
				})
		},
		getTugasPeserta() {
			const fmData = new FormData()
			fmData.append('id_materi', this.id_materi)
			fmData.append('id_pelatihan', this.id_pelatihan)
			axiosPostAuth('api/Pelatihan/getTugasPeserta', fmData)
				.then(response => {
					this.materi = Object.assign({}, response.data)
				})
				.catch(error => {
					alert(error)
				})
		},
		upload() {
			if (this.formUpload.editedIndex > -1) {
			} else {
				const fmData = new FormData()
				fmData.append('id_materi', this.id_materi)
				fmData.append('file', this.formUpload.file_temp)
				axiosPostAuth('api/Pelatihan/uploadTugas', fmData)
					.then(response => {
						if (response.code === 200) {
							this.getTugasPeserta()
						}
						else {
							alert(response.message)
						}
					})
					.catch(error => {
						alert(error)
					})
			}
		},
	}
}
</script>